import React from 'react';
import './index.scss';

type TagProps = {
  enable: boolean;
  enableText: string;
  disableText: string;
};

const StatusTag = (props: TagProps) => {
  const { enable, enableText, disableText } = props;
  return (
    <>
      {enable ? (
        <div className="enable-container">
          <i className="enable-icon"></i>
          <span className="tag-text enable-text">{enableText}</span>
        </div>
      ) : (
        <div className="disable-container">
          <i className="disable-icon"></i>
          <span className="tag-text disable-text">{disableText}</span>
        </div>
      )}
    </>
  );
};

export default React.memo(StatusTag);
